import {
    SAILS_BNT_STORAGE,
    SAILS_PARAM_GIGAKOMBI,
    SalesChannel,
    SALESCHANNEL_FAMILY_FRIENDS,
    SALESCHANNEL_REDPLUS,
    URL_PARAM_GIGAKOMBI,
} from '@vfde-sails/constants';
import { getSessionStorageItemJson } from '@vfde-sails/storage';
import { getQueryParam } from '@vfde-sails/utils';
import {
    APP,
    CONTAINER_TARIFF,
    GIGAKOMBI_TOKEN_PARAM,
} from '../../../app/constants';
import { getSubscriptionId } from './getSubscription';
import { SailsDeviceDetailsStorage } from '../../../interfaces/storage';

/**
 * Get gigakombi from session storage
 */
export const getGigakombi = (salesChannel: SalesChannel): boolean => {
    if (salesChannel === SALESCHANNEL_FAMILY_FRIENDS || salesChannel === SALESCHANNEL_REDPLUS) {
        return false;
    }

    const storage = getSessionStorageItemJson<SailsDeviceDetailsStorage | null>(SAILS_BNT_STORAGE);

    return getGigakombiFromUrl(salesChannel) ?? getGigakombiFromStorage(storage);
};

const getGigakombiFromUrl = (salesChannel: SalesChannel): true | undefined => {
    const gigakombiParam = getQueryParam(URL_PARAM_GIGAKOMBI);

    if (gigakombiParam && !getSubscriptionId(salesChannel)) {
        // eslint-disable-next-line no-console
        console.error('You used the gigakombi URL parameter without a tariff, which is not possible. Please add a tariff.');

        return undefined;
    }

    return (gigakombiParam === '1' || gigakombiParam === 'true' || undefined) ?? (!!getQueryParam(GIGAKOMBI_TOKEN_PARAM) || undefined);
};

const getGigakombiFromStorage = (storage: SailsDeviceDetailsStorage | null): boolean =>
    (storage?.[SAILS_PARAM_GIGAKOMBI] ?? storage?.[APP]?.[CONTAINER_TARIFF]?.[SAILS_PARAM_GIGAKOMBI]) || false;

/**
 * Get eligibility token
 */
export const getGigakombiEligibilityToken = (): string | null | undefined => getQueryParam(GIGAKOMBI_TOKEN_PARAM);
